import { useAuth } from '@/hooks/auth/use-auth';
import { useGroupSuspense } from '../api/get-group';
import { GroupStatus } from '@/types/api/group';
import { Navigate, Outlet } from 'react-router-dom';
import { paths } from '@/config/paths';

export function OnboardingGuard() {
  const { context } = useAuth();
  const { data: group } = useGroupSuspense({ groupId: context?.groupId! });

  if (group.status === GroupStatus.Onboarding) {
    return <Navigate to={paths.group.onboarding.getHref()} />;
  }

  return <Outlet />;
}
